import $ from 'jquery';

const PHI = (1 + Math.sqrt(5)) / 2;
const jumpTargets = [];
const $jumpNav = $('.jump-nav');
const $jumpNavMenu = $jumpNav.find('.jump-nav__menu');

$('a.jump-nav-anchor[id^="jn-"]').each((i, anchor) => {
    const $anchor = $(anchor);
    jumpTargets.push({
        id: $anchor.attr('id'),
        top: () => $anchor.offset().top,
    });
});


let lastClosest = null;
let isVisible = false;
const updateJumpNav = () => {
    // find closest
    const scrollTop = $(window).scrollTop();
    const scrollBottom = scrollTop + $(window).height();
    const comparisonTop = scrollBottom - (scrollBottom - scrollTop) / PHI;

    if (scrollTop > 200 && !isVisible) {
        isVisible = true;
        $jumpNav.addClass('jump-nav--show');
        window.requestAnimationFrame(() => $jumpNav.addClass('jump-nav--visible'));
    } else if (scrollTop <= 200 && isVisible) {
        isVisible = false;
        $jumpNav.removeClass('jump-nav--visible');
        window.setTimeout(() => $jumpNav.removeClass('jump-nav--show'), 200);
    }

    let closest = jumpTargets[0];
    for (let i = 1; i < jumpTargets.length; i++) {
        const target = jumpTargets[i];
        if (target.top() > comparisonTop) {
            break;
        }
        closest = target;
    }

    if (closest !== lastClosest) {
        lastClosest = closest;
        $jumpNavMenu.find('.jump-nav__link--active').removeClass('jump-nav__link--active');
        $jumpNavMenu.find(`a[href="#${closest.id}"]`).addClass('jump-nav__link--active');
    }
};

if (jumpTargets.length > 0) {
    $(window).on('scroll', updateJumpNav);
    updateJumpNav();
}
